module.exports = __webpack_public_path__ + "img/38_24.5c541983.png";